module.exports = __webpack_public_path__ + "static/media/8.004fa138.jpg";